import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { IMultiSelectService, MultiSelectServiceFactory } from './multi-select-service.interface';

@Injectable()
export class MultiSelectService {

    private subject = new BehaviorSubject<IMultiSelectService>(MultiSelectServiceFactory.create({}));
    private selectedSubject = new BehaviorSubject<string[]>([]);

    constructor() { }

    /**
     * Returns an observable that can be used to get the new service values.
     *
     * @returns
     */
    watchOptions(): Observable<IMultiSelectService> {
        return this.subject.asObservable();
    }

    /**
     * Emit new values.
     *
     * @param IMultiSelectService multiSelect
     */
    updateOptions(multiSelect: IMultiSelectService) {
        this.subject.next(multiSelect);
    }

    watchSelectedOptions(): Observable<string[]> {
        return this.selectedSubject.asObservable();
    }

    updateSelectedOptions(selectedOptions: string[]) {
        this.selectedSubject.next(selectedOptions);
    }
}
